import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Stock } from '@stockcare-storage/stock/stock';

@Component({
  standalone: false,
  selector: 'app-theatre-material-card',
  templateUrl: './theatre-material-card.component.html',
  styleUrls: ['./theatre-material-card.component.scss']
})
export class TheatreMaterialCardComponent implements OnInit {
  @Input() stock: Stock;
  @Output() stockClicked = new EventEmitter<Stock>();

  constructor() {}

  ngOnInit() {}

  cardClicked() {
    this.stockClicked.emit(this.stock);
  }
}
